import React from 'react';

import Immutable, { List } from 'immutable';

import { CoreLink, Paragraph } from '@uncinc/react-drupal-core';
import { Container, Image } from '@uncinc/uncinc-react-kitchen-sink';
import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../config/constants';

import './style.scss';

const ParagraphCta = ({ entity }) => {
  const plainText = entity.getIn(['field_plain_text', 0, 'value'], '');
  const name = entity.getIn(['field_name', 0, 'value'], '');
  const image = entity.getIn(['field_image', 0, 'styles'], null);
  const flipped = entity.getIn(['field_field_aligned_right', 0, 'value']);

  return (
    <Container className={`ParagraphCta ${flipped ? 'flipped' : ''}`}>
      {/* main cta paragraph content */}
      <div className="row">
        <div className="col-12 col-md-9 col-lg-10">
          <div className="ParagraphCta__wrapper">

            <div className="ParagraphCta__image">
              <div className="ParagraphCta__image--overlay" />
              <Image
                lazyload
                includeWebP
                alt=""
                src={{
                  [SCREEN_MOBILE]: image.getIn(['crop_1_1']),
                  [SCREEN_TABLET]: image.getIn(['crop_4_3']),
                  [SCREEN_NORMAL]: image.getIn(['crop_4_3']),
                }}
              />
            </div>

            <div className="ParagraphCta__content">
              <h3 className="ParagraphCta__quote">{plainText}</h3>
              <h4 className="ParagraphCta__author">{name}</h4>
            </div>

          </div>
        </div>
      </div>
      {/* end of main cta paragraph content */}

      {/* cta links start  */}
      <div className="ParagraphCta__cta__wrapper row">
        <div className="col-12">
          {entity.get('field_paragraphs', List()).size > 0 ? (
            <div className="ParagraphCta__paragraphs">
              {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
                const id = paragraph.get('target_id');
                const url = paragraph.getIn(['entity', 'field_link', 0, 'alias'], paragraph.getIn(['entity', 'field_link', 0, 'uri']));

                return (
                  <CoreLink
                    key={`paragraph:${id}`}
                    to={url}
                    className="ParagraphCta__link"
                  >
                    <Paragraph id={id} entity={paragraph.get('entity')} />
                  </CoreLink>
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
      {/* end of cta links */}
    </Container>
  );
};

export default ParagraphCta;
